/**
 * React Query hook for creating templates from proposals
 */
import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';
import { createTemplate } from '../services/TemplateService';
/**
 * Hook for creating templates from proposals
 * @returns Object containing the createTemplate mutation
 */
export default function useCreateTemplate() {
    const createTemplateMutation = useMutation(({ proposalId, templateData }) => createTemplate(proposalId, templateData), {
        onSuccess: (data) => {
            if (data.success) {
                toast.success(data.message || 'Template created successfully');
            }
            else {
                toast.error(data.error || 'Failed to create template');
            }
        },
        onError: (error) => {
            console.error('Error creating template:', error);
            toast.error('Failed to create template. Please try again.');
        }
    });
    return {
        createTemplate: createTemplateMutation
    };
}
